export const PLACE_HOLDER = {
  common: {
    select: '선택',
  },
};

export const ALERT_MSG = {
  common: {
    insert: '등록하시겠습니까?',
    update: '수정하시겠습니까?',
    delete: '삭제하시겠습니까?',
    save: '저장하시겠습니까?',
    loginError: '로그인 에러',
    noFile: '파일을 첨부하세요',
    uploadInfo: '장비 업로드가 시작됩니다.',
    otpExpired: 'OTP시간이 만료되었습니다.',
  },
  systemManagement: {
    userMgmt: {
      reject: '승인 거절하시겠습니까?',
      approval: '승인 완료하시겠습니까?',
      inactiveClear: '휴면 해제하시겠습니까?',
      availableLoginId: '사용가능한 아이디입니다',
      unavailableLoginId: '사용할 수 없는 아이디입니다',
      emptyLoginId: '로그인 ID를 입력하세요',
      duplicateCheckLoginId: '로그인 ID 중복확인을 하세요',
      pwdNotCorrect: '비밀번호와 비밀번호 확인이 다릅니다',
    },
    usrGrpMgmt: {
      availableLoginId: '사용가능한 이름입니다',
      unavailableLoginId: '사용할 수 없는 이름입니다',
      duplicateCheckLoginId: '그룹 이름을 중복확인 하세요',
      emptyLoginId: '그룹 이름을 입력하세요',
    },
  },
  management: {
    hostInfoMgmt: {
      updates: '대량으로 데이터가 수정됩니다. 계속 진행하시겠습니까?',
      oprtnTm: '설정된 플랫폼이 새로운 운용팀에 할당이 됩니다. 계속 진행하시겠습니까?',
      availableTmNm: '사용가능한 운용팀명 입니다',
      unavailableTmNm: '사용할 수 없는 운용팀명 입니다',
      emptyTmNm: '운용팀명을 입력하세요',
    },
    certificateMgmt: {
      upload: '인증서 업로드',
      uploadInfo: '인증서 업로드가 시작됩니다.',
    },
  },
};

export const SNACKBAR_MSG = {
  common: {
    insert: '등록되었습니다.',
    update: '수정되었습니다.',
    delete: '삭제되었습니다.',
    save: '저장되었습니다.',
    error: '에러가 발생하였습니다.',
  },
  alarmManagement: {
    test: '테스트를 완료하였습니다.',
    renewal: '갱신되었습니다.',
    reflection: '반영되었습니다.',
  },
  circuitInfo: {
    sync: '데이터가 갱신되었습니다.',
    syncAlready: '데이터가 이미 최신 상태입니다.',
    syncFailed: '데이터 갱신에 실패하였습니다.',
  },
  configurationManagement: {
    channelMgmt: {
      copy: '복사되었습니다.',
    },
  },
  systemManagement: {
    userMgmt: {
      reject: '승인 거절되었습니다.',
      approval: '승인 완료되었습니다.',
      inactiveClear: '휴면 해제되었습니다.',
    },
  },
};

export const MENU_PAGE_TITLE = {
  dashboard: {
    title: '대시보드',
    dashboard: '대시보드',
    performance: '성능현황',
  },
  statistics: {
    title: '알람 관리',
    report: '알람 레포트',
    history: '알람 이력 조회',
  },
  cdr: {
    title: 'CDR',
    search: 'CDR 검색',
  },
  standardInfomation: {
    title: '기준 정보',
    tdm: 'TDM 선번장 관리',
    stp: 'STP 선번장 관리',
    sigtran: 'SIGTRAN 선번장 관리',
    dra: 'DRA 선번장 관리',
    c3: 'C3 알람 관리',
    stpAlarm: 'STP 알람 관리',
  },
  systemManagement: {
    title: '시스템 관리',
    userMgmt: '사용자 관리',
    groupMgmt: '그룹 관리',
    groupMenuMgmt: '그룹 메뉴 관리',
    apiHistory: 'API 이력 조회',
  },
};

export const DIALOG_TITLE = {
  login: {
    otp: {
      title: 'OTP 인증',
      modal: 'OTP 번호입력',
    },
  },
  systemManagement: {
    userMgmt: {
      detail: '사용자 상세정보',
      insert: '사용자 등록',
      update: '사용자 수정',
    },
    groupMgmt: {
      detail: '그룹 상세보기',
      insert: '그룹 등록',
      update: '그룹 수정',
    },
  },
  management: {
    monitoring: {
      detail: '감시시설 상세',
      insert: '경보 제외 등록',
    },
    hostInfoMgmt: {
      detail: '호스트 상세',
      insert: '신규 호스트 등록',
      update: '호스트 수정',
      updateBatch: '호스트 일괄 수정',
      platformMgmt: '플랫폼 조직 관리',
      operationTeam: '운용팀 등록',
    },
    certificateMgmt: {
      detail: '인증서 상세',
      insert: '인증서 등록',
      update: '인증서 수정',
      updates: '인증서 일괄 등록/수정',
    },
  },
};

export const FORMSET_TITLE = {
  systemManagement: {
    userMgmt: {
      basicInfo: '기본정보',
    },
    groupMgmt: {
      basicInfo: '기본정보',
    },
    apiHistorySearch: {
      basicInfo: '기본정보',
    },
    ppCompanyMgmt: {
      basicInfo: '기본정보',
    },
  },
  alarmManagement: {
    pairAlarmMgmt: {
      basicInfo: '기본정보',
      eventType: '알람 유형',
    },
    ruleset: {
      basicInfo: '기본정보',
      textMappingList: 'TEXT 매핑 리스트',
      ruleSetMappingInfo: 'RuleSet 매핑 정보',
      MappingCondition: '매핑 조건',
    },
    snmpRuleset: {
      basicInfo: '기본정보',
      settingInfo: '설정 정보',
    },
    stbSimulator: {
      basicInfo: '기본정보',
    },
  },
};

export enum BUTTON_LABEL {
  CLOSE = '닫기',
  ABLE_LOGIN = '로그인방지해제',
  WAKEUP = '휴면해제',
  REFUSAL = '승인거절',
  APPROVED = '승인완료',
  DELETE = '삭제',
  INSERT = '등록',
  UPDATE = '수정',
  CONFIRM = '확인',
  SAVE = '저장',
  CANCLE = '취소',
  SEARCH = '검색',
  ADD = '추가',
  EXPORT_PDF = 'PDF 내보내기',
  TEST = '테스트',
  ACK = 'ACK',
  PURGE = 'Purge',
  TERMINATE = 'Terminate',
  CLEAR = 'Clear',
  ATTACH_FILE = '파일 첨부',
  INSPECTION_HISTORY = '점검이력',
  ALARM_DETAILS = '알람 상세보기',
  CHANGE_PASSWORD = '비밀번호 변경',
  ID_DUPLICATE_CHECK = 'ID 중복확인',
  GRP_DUPLICATE_CHECK = '그룹 이름 중복확인',
  DUPLICATE_CHECK = '중복 확인',
  CHANNEL_LINE_REGISTER = '채널 선번장 등록',
  CHANNEL_LINE_TEMPLATE_DOWNLOAD = '템플릿 다운로드',
  CHANNEL_LINE_DOWNLOAD = '채널 선번장 다운로드',
  CHANNEL_HISTORY = '채널 변경이력',
  LOGIN = 'Login',
  KDB = 'KDB',
  EVENT_SELECT = '알람 선택',
  EVENT_DETAIL = '알람 선택',
  HOSTNM_DUPLICATE_CHECK = '호스트명 중복확인',
  RPA_TEMPLATE_DETAILS = 'RPA 템플릿 상세보기',
  RPA_TEMPLATE_SELECT = 'RPA 템플릿 선택',
  EQUIPMENT_DETAILS = '장비 상세보기',
  EQUIPMENT_SELECT = '장비 선택',
  EQUIPMENT_MAIN_SELECT = '대표장비 선택',
  EQUIPMENT_PAIRINSERT = '장비 생성',
  EQUIPMENT_PAIRUPDATE = '대상장비 수정',
  SERVER_DETAIL = '서버 상세보기',
  SERVER_SELECT = '서버 선택',
  INTERACTIVESYS_DETAIL = 'NMS 상세보기',
  INTERACTIVESYS_SELECT = 'NMS 선택',
  PP_SELECT = 'PP사 선택',
  SAID_DUPLICATE_CHECK = 'SAID 중복확인',
  ALARM_SELECT = '알람 선택',
  CONNECTION_DETAILS = 'Connection 상세보기',
  RUNNING_CONSOLE_CONFIRM = '실행 콘솔 확인',
  STOP_RUNNING = '실행 중지',
  RE_RUNNING = '재실행',
  STOP_TEST = '테스트 중지',
  TRANSFER_HISTORY = '절체이력',
  COPY = '복사',
  MIB_UPLOAD = 'MIB 등록',
  COPY_M_TO_B = '입력값 복사(M->B)',
  INIT_DATA_SAVE = '초기 데이터 저장',
  EQUIP_GROUP_INSERT = '장비 그룹 등록',
  EQUIP_GROUP_UPDATE = '장비 그룹 수정',
  CHANNEL_UPDATE = '채널정보 갱신',
  UPLOAD = '업로드',
  DOWNLOAD = '다운로드',
  EQUIP_TEMPLATE_DOWNLOAD = '장비템플릿 다운로드',
  EQUIP_UPLOAD = '장비업로드',
  RE_SEND = '재전송',
  DATA_UPDATE = '연동 데이터 갱신',
  EXCEL_DOWNLOAD = '엑셀 다운로드',
  EXCEL_INSERT = '일괄 등록/수정',
  PLATFORM_MGMT = '플랫폼 조직 관리',
  OPRTNTMNM_DUPLICATE_CHECK = '운용팀명 중복확인',
  SERVICE_ADD = '서비스 추가',
  PLATFORM_ADD = '플랫폼 추가',
  EXCEPT_INSERT = '제외등록',
  EXCEPT_CANCLE = '제외취소',
}
